import Head from "next/head";
import { useRouter } from "next/router";

import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Pagination from 'react-bootstrap/Pagination';

import { request } from "graphql-request"

import { GET_YACHTS, GET_MENU_YACHTS, GET_FOOTER, GET_LATEST_YACHTS, GET_SEARCHBAR_DATA, GET_TAGS, GET_BRAND_IMAGE } from "../../lib/queries";
import { Header } from "../../components/Header";
import Layout from "../../components/layout";
import SearchBar from "../../components/SearchBar";
import { YachtCard } from "../../components/yachts/YachtCard";
import styles from '../../styles/yachts.module.scss'
import { useEffect, useState } from "react";

export async function getServerSideProps(context) {
  try{
    const { locale } = context;
    const { brand = '' } = context.query;
    const { model = '' } = context.query;
    const { size = '' } = context.query;
    const { tags = '' } = context.query;
  
    const { page = 1 } = context.query;
    const startIndex = +page == 1 ? 0 : (+page - 1) * 20;
    let count;
    await fetch("https://yachting-mexico.herokuapp.com/yachts/count")
      .then((res) => {
        return res.json(); 
      })
      .then((data) => {
        count = data;
      });
  
    const { yachts } = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_YACHTS,
      {
        start: startIndex,
        locale: locale,
        brandSlug: brand,
        modelSlug: model,
        sizeSlug: size,
        tagsSlug: tags.length > 0 ? tags.split("_") : undefined
      },
    )
    const { yachts: navbar } = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_MENU_YACHTS,
      { locale: locale },
    )
    const { footer } = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_FOOTER,
      { locale: locale },
    )
    const { yachts: latestYachts} = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_LATEST_YACHTS,
      { locale: locale },
    )
    const { yachts: searchbarData } = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_SEARCHBAR_DATA
    )
    const { tags: tagsData } = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_TAGS,
      { locale: locale },
    )
    const { brands } = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_BRAND_IMAGE,
      { locale: locale, brandSlug: brand, }
    )
  
    if (!yachts || !footer || !latestYachts) {
      return {
        notFound: true,
      };
    }
  
    return {
      props: {
        activePage: +page,
        numberOfYachts: count,
        yachts,
        navbar,
        footer,
        latestYachts,
        queryBrand: brand,
        queryModel: model,
        querySize: size,
        queryTags: tags,
        searchbarData,
        tagsData,
        backgroundImage: brands[0].Background_Media.url
      },
    };
  }catch(e){
    return {
      notFound: true,
    };
  }
  
}

export default function Yachts({
  activePage,
  numberOfYachts,
  yachts,
  navbar,
  footer,
  latestYachts,
  queryBrand,
  queryModel,
  querySize,
  queryTags,
  searchbarData,
  tagsData,
  backgroundImage
}) {


  const router = useRouter();
  const [order, setOrder] = useState([]);
  const [grouped, setGrouped] = useState([]);

  const numberOfPages = 1;

  let pages = [];
  
  for (let number = 1; number <= numberOfPages; number++) {
    pages.push(
      <Pagination.Item
        key={number}
        onClick={() => {
          router.push({
            pathname: '/yachts',
            query: {
              brand: queryBrand,
              model: queryModel,
              size: querySize,
              tags: queryTags,
              page: number
            }
          })
        }}
        active={number == activePage}
        activeLabel=""
        className="px-2"
      >
        {number}
      </Pagination.Item>
    );
  }

  
  useEffect(() => {
    const uniqueNames = [...new Set(yachts.map(item => item.model.model))];
  
    // Orden personalizado para los modelos
    const sortOrder = ['LEADER WA', 'NC WEEKENDER', 'DB', 'LEADER CC', 'NC SPORT', 'S-LINE', 'F-LINE','X-LINE', 'M-LINE'];
  
    // Reordenar los nombres de los modelos según el orden personalizado
    uniqueNames.sort((a, b) => {
      const upperA = a.toUpperCase();
      const upperB = b.toUpperCase();
  
      const indexA = sortOrder.indexOf(upperA);
      const indexB = sortOrder.indexOf(upperB);
  
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      return 0;
    });
  
    
  
    // Agrupación de datos
    const groupedData = [];
    uniqueNames.map((name) => {
      groupedData.push({
        model: name,
        yachts: yachts.filter((yacht) => yacht.model.model === name)
      });
    });
  
    // Ordenar yates dentro de cada modelo por tamaño
    const sorted = [];
    groupedData.forEach((model) => {
      const modelOrdered = model.yachts.sort((n1, n2) => {
        if (parseFloat(n1.size.size) > parseFloat(n2.size.size)) {
          return 1;
        }
        if (parseFloat(n1.size.size) < parseFloat(n2.size.size)) {
          return -1;
        }
        return 0;
      });
  
      // Actualizar el arreglo de yates del modelo
      model.yachts = modelOrdered;
  
      // Agregar los yates ordenados al arreglo 'sorted'
      modelOrdered.forEach((item) => {
        sorted.push(item);
      });
    });
  
    // Actualizar el estado
    setGrouped(groupedData);
    setOrder(sorted);
  }, []);
  
  return (
    <Layout header={navbar} footer={footer} latestYachts={latestYachts}>
      <Head>
        <title>Yachting México | {router.locale === "es" ? "Yates" : "Yachts"}</title>
        <meta
          name="description"
          content="Discover the yacht of your dreams between all our models"
        />
      </Head>

      <Header
        title={router.locale === "es" ? "Yates" : "Yachts"}
        imgSrc={backgroundImage}
        imgAlt="Yachts sailing on lake with emerald-like water"
      />
      <div style={{overflowX:"hidden"}}>
        <Container className={`${styles.yachts} mb-2 mb-md-4 mb-lg-6`} >
          <Row >
            <Col xs={12}>
              <SearchBar
                content={searchbarData}
                queries={[queryBrand, queryModel, querySize, queryTags]}
                tagsData={tagsData}
              />
            </Col>

            {yachts.length == 0
              ?
              <h2 className="text-center">
                {router.locale === "es" ?
                  "No se encontraron yates con esta combinación" :
                  "No yachts with this combination were found"}
              </h2>
              : 
              grouped.map((model,idx)=>{
                return(
                  <Row>
                  <h3 className={styles.yachtsModel}>{model.model}</h3>
                  <div className={styles.yachtsModels}>
                    {
                      model.yachts.map((yacht,idx)=>{
                        return(
                         
                            <YachtCard
                              slug={yacht.slug}
                              image={yacht.thumbnail.url}
                              altText={yacht.thumbnail.alternativeText}
                              size={yacht.size?.size}
                              model={yacht.model?.model}
                              brand={yacht.brand?.brand}
                              isNew={yacht.isYachtNew}
                              status={yacht.status}
                            />
                          
                        )
                      })
                    }
                  </div>
                  </Row>
                )
                
            
              })
              
            }

                        
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

